exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header{background-color:#fbfbfb}.setting-body{background-color:#fdfdfd}input,textarea{border-style:solid}.token_password_toggle{position:absolute;margin-top:-30px;right:20px}.settings-wrapper fieldset{border:1px solid rgba(25,35,58,.3)!important}", ""]);

// exports
